export function chunck(array: string | any[], by: number): string[] {
  const chuncks = [];
  for (let iter = 0; iter < array.length / by; iter++) {
    chuncks.push(array.slice(iter * by, by + iter * by));
  }
  return chuncks;
}
